import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { RecordedDocumentsTableDefinitionZod } from '../tables';

type Arguments = { id: string; position?: number };
export const schemaLoanRequestResolver_GetAcknowledgedDocuments = z.array(
    z.object({
        key: RecordedDocumentsTableDefinitionZod.shape.documents.element.shape.key,
        name: RecordedDocumentsTableDefinitionZod.shape.documents.element.shape.name,
        uploadedTo: RecordedDocumentsTableDefinitionZod.shape.documents.element.shape.uploadedTo,
    }),
);

export type SchemaLoanRequestResolver_GetAcknowledgedDocuments = z.infer<
    typeof schemaLoanRequestResolver_GetAcknowledgedDocuments
>;

export type LoanRequestResolver_GetAcknowledgedDocuments = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetAcknowledgedDocuments
>;
